var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339 812 c-146 -59 -234 -214 -209 -366 43 -263 358 -374 555 -195 178 163 139 438 -78 551 -60 31 -203 36 -268 10z m257 -26 c63 -29 116 -81 151 -149 24 -45 28 -64 28 -137 0 -101 -21 -154 -91 -226 -66 -67 -120 -89 -224 -89 -73 0 -92 4 -135 27 -62 32 -129 103 -158 166 -32 70 -30 179 6 253 77 161 261 228 423 155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 576 l39 -32 -38 -29 c-21 -16 -32 -31 -26 -33 7 -2 31 11 53 29 l42 33 -39 33 c-21 18 -46 33 -54 32 -9 0 1 -13 23 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 579 c-23 -17 -42 -32 -42 -34 0 -6 84 -65 92 -65 18 0 6 16 -29 39 l-37 24 25 18 c62 46 65 48 48 49 -8 0 -34 -14 -57 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 387 c-22 -7 -41 -18 -43 -24 -3 -9 9 -8 42 4 46 15 126 14 168 -2 9 -4 17 -3 17 3 0 25 -125 38 -184 19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnger);
export default __webpack_public_path__ + "static/media/anger.2caa7094ad2e36e83850d2cdfd235872.svg";
export { ForwardRef as ReactComponent };